import { Component, ChangeDetectionStrategy, SimpleChanges, afterRenderEffect, input, untracked, signal, computed } from '@angular/core';
import { BitwiseToArray, IMenu, menuOptions, Store } from '../../../types';
import { BucketPipe } from '../../../bucket.pipe';
import { SafePipe } from '../../../safe.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyPipe, NgTemplateOutlet } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaintDirective } from '../../../paint.directive';
import { IsNumberPipe } from '../../../is-number.pipe';

@Component({
  selector: 'menu-render',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, BucketPipe, SafePipe, NgTemplateOutlet, MatDivider, CurrencyPipe, MatTooltipModule, PaintDirective, IsNumberPipe]
})
export class MenuComponent {

  stores = input.required<Store[]>();
  selected_menu = signal<IMenu|null>(null);

  menu_options = computed(() => {
    const stores = this.stores();

    return stores?.map(s => s.menus || []).flat()?.reduce<{ [key: string]: { key: string; value: number; icon: string; }[] }>((cleaned, entry) => {
      if(!cleaned[entry._id]){
          cleaned[entry._id] = this.optionStrings(entry.options);
      }
      return cleaned;
    }, {}) || {};
  });

  constructor() { 

    afterRenderEffect(() => {
      const stores = this.stores();

      untracked(() => {
        if(stores.length == 1 && stores.at(0)?.menus?.length == 1){
          this.selected_menu.set(stores.at(0)?.menus?.at(0) ?? null);//!null should never happen here but just in case
        } else {
          this.selected_menu.set(null);
        }
      });
    });

  }


  optionStrings(options: number) {
    let optionsArray = BitwiseToArray(options);

    if(!optionsArray || !optionsArray.length) return [];

    return menuOptions.filter(option => optionsArray.includes(option.value));
  }

  parsePrice = (price: string | number) => {
    if(isNaN(Number(price))){
      return price;
    } else {
      return '€ ' + Number(price).toFixed(2);
    }
  }

}
